import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@pella/cosmos-react';
import { QUERY_KEYS } from '../../utils/enums';

/**
 * Hook to fetch intercompany codes filtered by chart of accounts segments.
 * @param {string} division - The division code to filter by.
 * @param {string} location - The location code to filter by.
 * @param {string} costCenter - The cost center code to filter by.
 * @param {string} account - The account code to filter by.
 * @param {string} segment - The segment code to filter by.
 * @returns {object} Intercomps query result with data, loading, success, and error states.
 */
export const useIntercomps = (division, location, costCenter, account, segment) => {
  const { api, apiReady } = useAPI();
  const { data, isLoading, isSuccess, isError, error } = useQuery({
    queryKey: [QUERY_KEYS.INV_MGMT_INTERCOMPS, division, location, costCenter, account, segment],
    queryFn: () => api.invMgmt.getInterComp({ division, location, costCenter, account, segment }),
    enabled:
      apiReady && Boolean(division) && Boolean(location) && Boolean(costCenter) && Boolean(account) && Boolean(segment),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    intercomps: data,
    intercompsIsLoading: isLoading,
    intercompsIsSuccess: isSuccess,
    intercompsIsError: isError,
    intercompsError: error,
  };
};
